import { useAtomValue } from 'jotai'
import React from 'react'

import {
  buildFiveSegmentsAnswersArrayData,
  type FiveSegmentsAnswerData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { type Brand } from '~/hooks/useSurveyQuery'

import { fiveSegmentSortFunctionAtom } from '../atoms'

import { useGetFiveSegmentsData } from './useGetFiveSegmentsData'
import { useNineSegmentsAnswersArrayData } from './useNineSegmentsAnswersArrayData'

export const useFiveSegmentsAnswersArrayData = (
  brand: Brand,
): FiveSegmentsAnswerData[][] => {
  const nineSegmentsAnswersArrayData = useNineSegmentsAnswersArrayData(brand)
  const getFiveSegmentsData = useGetFiveSegmentsData(brand)
  const sort = useAtomValue(fiveSegmentSortFunctionAtom)

  return React.useMemo(
    () =>
      buildFiveSegmentsAnswersArrayData({
        getFiveSegmentsData,
        nineSegmentsAnswersArrayData,
        sort,
      }),
    [getFiveSegmentsData, nineSegmentsAnswersArrayData, sort],
  )
}
